import {z} from 'zod';
import paginatedSchema from "../common/paginatedSchema";

const clubSchema = z.object({
    id: z.number(),
    name: z.string()
        .min(1, {message: "Název klubu nesmí být prázdný"})
        .max(100, {message: "Název klubu nesmí být delší než 100 znaků"}),
});

const paginatedClubsSchema = paginatedSchema(clubSchema);

type Club = z.infer<typeof clubSchema>;
type PaginatedClubs = z.infer<typeof paginatedClubsSchema>;

export {clubSchema, type Club, paginatedClubsSchema, type PaginatedClubs};
